import React from 'react';

import {
    findSkillBest
} from '../utils.js';


export default function ({allSkillData}) {

    

    if (!allSkillData.length) {
        return null;
    }

    return (
        <div className="tsp-graduate">
            <div className="tsp-header">
                Graduate Profile
            </div>
            <div className="tsp-graduate-skills flex-row flex-gap-25 flex-wrap">
                <div className="graduate-skills-item">
                    <div>
                        <i className="fas fa-brain" style={{color: 'blue'}}></i>
                        {`Critical Thinker & Problem Solver`}
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Ability to Reason`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 2')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Construct Arguments`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 3')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Critique Reasoning`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 4')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Model & Predict`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 6')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Decision Making`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 12')}</div>
                    </div>
                </div>

                <div className="graduate-skills-item">
                    <div>
                        <i className="fas fa-comments" style={{color: 'green'}}></i>
                        {`Effective Communicator`}
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Effective Writing`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 9')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Communicate Effectively`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 8')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Work Precisely`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 5')}</div>
                    </div>
                </div>

                <div className="graduate-skills-item">
                    <div>
                        <i className="fas fa-users" style={{color: 'purple'}}></i>
                        {`Collaborator`}
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Collaboration`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 10')}</div>
                    </div>
                </div>

                <div className="graduate-skills-item">
                    <div>
                        <i className="fas fa-lightbulb" style={{color: 'orange'}}></i>
                        {`Creative & Innovative Thinker`}
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Creative Thinking`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 13')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Think Flexibly`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 11')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Transfer Ideas`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 7')}</div>
                    </div>
                </div>

                <div className="graduate-skills-item">
                    <div>
                        <i className="fas fa-globe" style={{color: 'purple'}}></i>
                        {`Globally Competent Citizen`}
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Think Flexibly`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 11')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Critique Reasoning`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 4')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Collaboration`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 10')}</div>
                    </div>
                </div>

                <div className="graduate-skills-item">
                    <div>
                        <i className="fas fa-graduation-cap" style={{color: 'darkred'}}></i>
                        {`Self-Directed Learner`}
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Grit`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 1')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Transfer Ideas`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 7')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Decision Making`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 12')}</div>
                    </div>
                </div>

                <div className="graduate-skills-item">
                    <div>
                        <i className="fas fa-heart" style={{color: 'deeppink'}}></i>
                        {`Empathetic Leader`}
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Grit`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 1')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Collaboration`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 10')}</div>
                    </div>
                    <div className="flex-row flex-gap-20">
                        <div>{`Decision Making`}</div>
                        <div>{findSkillBest(allSkillData, 'Skill 12')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}